<template>
  <v-dialog v-model="showModal" width="400" @click:outside=closeDialog>
      <v-card max-width="400">
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="text-h5 text-medium-emphasis ps-2 title-text" >edit category</div>
          <v-btn icon="mdi-close" variant="text" @click=closeDialog></v-btn>
        </v-card-title>
        <v-divider class="mb-4"></v-divider>
        <v-card-text>
          <v-sheet class="mx-auto" width="300">
            <v-form @submit.prevent ref="form">
              <v-text-field label="id" variant="underlined" class="form_field" v-model="this.currentRow.id" disabled></v-text-field>
              <v-text-field :rules="[required]" label="ticker" variant="underlined" class="form_field" v-model="this.currentRow.ticker"></v-text-field>
              <v-select
                label="select broad"
                :items="broads"
                item-title="name"
                item-value="id"
                v-model="this.currentRow.broad.id"
                :rules="[required]"
              ></v-select>
              <v-select
                label="select type"
                :items="types"
                item-title="name"
                item-value="id"
                v-model="this.currentRow.type.id"
                :rules="[required]"
              ></v-select>
              <v-select
                label="select country"
                :items="countries"
                item-title="name"
                item-value="id"
                v-model="this.currentRow.country.id"
                :rules="[required]"
              ></v-select>
            </v-form>
          </v-sheet>
        </v-card-text>
        <template v-slot:actions>
          <v-row align="center" justify="end" class="actionsRow">
            <v-btn v-on:click="submitUpdateRecord" class="mt-2 submit_button" type="submit" block>update</v-btn>
            <v-btn v-on:click="submitDeleteRecord" class="mt-2 submit_button" type="submit" block>delete</v-btn>
          </v-row>
        </template>
      </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations} from 'vuex';

export default {
  props: {
    show: Boolean,
    currentRow: Object
  },
  data() {
    return {
      broads: [],
      types: [],
      countries: [],
      
    }
  },
  async created() {
    this.getBroads();
    this.getTypes();
    this.getCountries();

  },
  computed: {
    ...mapState({
      token: "token"
    }),
    showModal: {
      get () {
        return this.show
      }
    },
  },
  methods: {
      ...mapMutations(["showSnackbar"]),  
    async getBroads(){
      try {
      const response  = await axios.get("/securities/categorisations/config/broads",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
        this.broads = response.data;
      
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load broad categories' });
      }
    },
    async getTypes(){
      try {
      const response  = await axios.get("/securities/categorisations/config/types",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
        this.types = response.data;
      
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load security types' });
      }
    },
    async getCountries(){
      try {
      const response  = await axios.get("/securities/categorisations/config/countries",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
        this.countries = response.data;
      
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load countries' });
      }
    },
    async submitUpdateRecord(e) {
      try {
        e.preventDefault();
        await axios.request({
          url: "/securities/categorisations/" + this.currentRow.id,
          method: "PUT",
          headers: {
              Authorization: `Bearer ${this.token}`
          },
          data: {
            ticker: this.currentRow.ticker,
            broad_id: this.currentRow.broad.id,
            type_id: this.currentRow.type.id,
            country_id: this.currentRow.country.id
          }
        });
          this.$parent.getCategories(); // update list on local
          this.$emit("close"); // close modal via parent
      } catch (error) {
        this.showSnackbar({ message: 'Failed to update security categorisation' });
      }
    },
    async submitDeleteRecord(e) {      
      try {
        e.preventDefault();
        await axios.delete('/securities/categorisations/' + this.currentRow.id,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
          }
        });
          this.$parent.getCategories(); // update list on local
          this.$emit("close"); // close modal via parent

      } catch (error) {
        this.showSnackbar({ message: 'Failed to delete security categorisation' });
      }
    },
    required (v) {
        return (v !== null && v !== undefined && v !== '') || 'required'
    },
    closeDialog(){
      // this.resetDataValues();
      this.$parent.getCategories();
      this.$emit('close');
    }, 
  } 
}
</script>

<style scoped>
.title-text, .body-text, .form_field, .submit_button {
  font-family: "Space Grotesk", "Courier New", Courier, monospace, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.actionsRow{
  margin-bottom: 5px;
}

</style>